import { useCallback, useEffect, useMemo } from 'react';
import useUrlState from '../../hooks/useUrlState';
import { removeUndefinedProperties } from '../utils';
import { useFetchTemplatesQuery } from '../service';

export default function useGetCurrentCustomReport() {
    const [urlState, setUrlState] = useUrlState();
    const { template_guid: templateGuid, report_guid: reportGuid, report_url: reportUrl } = urlState;

    const { data: templates, isLoading: isLoadingTemplates } = useFetchTemplatesQuery();

    const currentTemplate = useMemo(() => templates?.find((template) => template.guid === templateGuid), [templateGuid, templates]);

    const setCustomReport = useCallback(
        (templateGuid: string, reportGuid?: string, reportUrl?: string) => {
            const newState = removeUndefinedProperties({
                template_guid: templateGuid,
                report_guid: reportGuid,
                report_url: reportUrl && encodeURIComponent(reportUrl),
            });
            setUrlState(newState);
        },
        [setUrlState]
    );

    useEffect(() => {
        if (templates) {
            const templateGuids = templates.map((template) => template.guid);
            const firstTemplateGuid = templateGuids[0];

            if ((!templateGuid || !templateGuids.includes(templateGuid)) && firstTemplateGuid) {
                const newState = removeUndefinedProperties({
                    template_guid: firstTemplateGuid,
                    report_guid: reportGuid,
                    report_url: reportUrl && encodeURIComponent(reportUrl),
                });

                setUrlState(newState);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [templateGuid, templates]);

    return {
        currentTemplate,
        templateGuid,
        reportGuid,
        reportUrl: reportUrl && decodeURIComponent(reportUrl),
        isLoadingTemplates,
        setCustomReport,
    };
}
